import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
import { QuartoPiece } from './QuartoPiece';
export class QuartoState extends GameStateWithTable {
    pieceInHand;
    constructor(b, turn, pieceInHand) {
        super(b, turn);
        this.pieceInHand = pieceInHand;
    }
    static isGivable(piece, board, pieceInHand) {
        if (piece === pieceInHand) {
            return false;
        }
        return QuartoState.isAlreadyOnBoard(piece, board) === false;
    }
    static isAlreadyOnBoard(piece, board) {
        // return true if the piece is already placed on the board
        for (let indexY = 0; indexY < 4; indexY++) {
            for (let indexX = 0; indexX < 4; indexX++) {
                if (board[indexY][indexX] === piece) {
                    return true;
                }
            }
        }
        return false;
    }
    getRemainingPieces() {
        // return the piece that are nor on the board nor the one that you have in your hand
        // (hence, the one that your about to put on the board)
        const allPawn = QuartoPiece.pieces;
        const remainingPawns = [];
        for (const piece of allPawn) {
            if (QuartoState.isGivable(piece, this.board, this.pieceInHand)) {
                remainingPawns.push(piece);
            }
        }
        return remainingPawns;
    }
}
